import { Component, EventEmitter, Input, Output, OnChanges } from '@angular/core';
import { AppState } from '../../../../../../app.service';
import { Service } from '../../../direct-connect.service';

import { TranslateService, TranslatePipe, LangChangeEvent } from '@ngx-translate/core';
import { GlobalVariables } from '../../../../../../../common/global-variables';
let $ = require('jquery');
import { IpValidationUtils  } from '../../../../../../../common/validations/ip-validation-utils';

@Component({
  selector: 'edit-configure-gateway',
  styles: [require('../../../direct-connect.scss')],
  template: require('./edit-configure-gateway.html'),
    providers: [
    Service, TranslateService
  ]
})

export class EditConfigureGateway {


  @Input() createData: any;
  @Input() isWizardOpen: boolean = false;
  @Input() stepId: number;
  @Input() networkDetail: any;
  @Input() showBusy: boolean = false;
  @Input() editData: any;
  @Output() stepEventEmitter: EventEmitter<any> = new EventEmitter();

  private subscribeHandler;
  private isTranslationready: boolean = true;
  private ipValidationUtils: IpValidationUtils = new IpValidationUtils();
  private arrEdgesConnected: Array<any> = [];
  private htmlIPRanges: any;
  private dataModel = {
    ipRanges: [],
    isIpRangeValid: false,
	  edgeId: "",
	  edgeName: "",
    maskBits: "",
    gatewayAddress: "",
    isStepValid: true,
    stepId: -1
  };

  ngOnInit() {

  }

  ngOnChanges(changes) {
    if (!this.isWizardOpen) {
        return;
    }
    if (this.stepId >= 0) {
        this.dataModel.stepId = this.stepId;
    }


    if (this.editData) {
        let edge = this.editData.edge;
        this.dataModel.ipRanges = edge.ipRanges;
        this.dataModel.maskBits = edge.maskBits;
        this.dataModel.gatewayAddress = edge.gatewayAddress;
        this.dataModel.isStepValid = true;
    }

  }

  constructor(public appState: AppState,
            public service: Service,
            private translate: TranslateService) {
      translate.use(GlobalVariables.LOCALE);
   }

  transitFormValid(event) {
    this.dataModel.isStepValid = (event.valid) ? event.valid : false;
    this.emitData();
  }

  setIpRanges(event) {
    this.dataModel.ipRanges = (event.data) ? $.extend(true, [], event.data) : [];
    this.emitData();
  }

  emitData() {
    this.stepEventEmitter.emit(this.dataModel);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/network/direct-connect/wizards/edit-gateway/steps/edit-configure-gateway.component.ts